export default __webpack_public_path__ + "assets/mp3/ac7988a448659aacd2805680b5da5a79.mp3";